import button from './ReportButton.vue'
const ReportButton = {
  install: function (Vue) {
    Vue.component('ReportButton', button)
  }
}
export default ReportButton
